import Reactor from '../reactor';

export default {
    STORE_USER_DATA: 'STORE_USER_DATA',
    STORE_USER_LINKS: 'STORE_USER_LINKS',
    SET_CHART_PREFERENCE: 'SET_CHART_PREFERENCE',
    SET_PROFILE_CHANGE_CHECK_COMPLETED: 'SET_PROFILE_CHANGE_CHECK_COMPLETED',

    storeUserData: function(data) {
        Reactor.dispatch(this.STORE_USER_DATA, data);
    },
    storeUserLinks: function(menus) {
        Reactor.dispatch(this.STORE_USER_LINKS, menus);
    },
    setChartPreference: function(chartSeriesIndex, chartSeriesIndexPreference) {
        const payload = {
            chartSeriesIndex: chartSeriesIndex,
            chartSeriesIndexPreference: chartSeriesIndexPreference,
        };
        Reactor.dispatch(this.SET_CHART_PREFERENCE, payload);
    },
    setProfileCheckCompleted: function(completedYn) {
        Reactor.dispatch(this.SET_PROFILE_CHANGE_CHECK_COMPLETED, completedYn);
    },
};
